module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fcenter2"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("For the women of Maui:")]), _vm._v(" "), _c('p', {
    staticClass: "fcenter"
  }, [_vm._v("Ann Hood, Diane Lake, Annie LeClaire, Jacquelyn Mitchard, Deborah Todd, and Sara Young.")]), _vm._v(" "), _c('p', {
    staticClass: "fcenter1"
  }, [_vm._v("And in loving memory of Heiman Zeidman.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a0f472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedication.vue
// module id = 72
// module chunks = 0